import videojs from 'video.js';

const MenuButton = videojs.getComponent('MenuButton');
const MenuItem = videojs.getComponent('MenuItem');
const Menu = videojs.getComponent('Menu');

class SettingsButton extends MenuButton {
    constructor(player, options) {
        super(player, options);

        this.addClass('vjs-settings-button');
        this.controlText('Settings');
        this.selectedSpeedItem = null; // Track the currently selected speed item

        // Remove any default menu if present
        this.removeChild('menu');

        // Create and add the custom menu with playback speeds and skip options
        this.menu = this.createMenu();
        this.menu.addChild(this.createSkipForward());
        this.menu.addChild(this.createSkipBackward());
        this.menu.addChild(this.createDivider());
        this.menu.addChild(this.createPlaybackSpeedMenu());
        this.menu.addClass('vjs-settings-menu');
        this.children_[0]?.addClass('vjs-icon-cog');

        document.addEventListener('click', this.closeMenuOnOutsideClick);
    }

    closeMenuOnOutsideClick = (event) => {
        if (!this.menu.el().contains(event.target)) {
            this.menu.removeClass('vjs-lock-showing');
        }
    };

    // Create and return the menu
    createMenu() {
        const menu = new Menu(this.player(), {
            menuButton: this,
            className: 'vjs-settings-menu',
        });
        this.addChild(menu);
        return menu;
    }

    createDivider() {
        const divider = new MenuItem(this.player(), {
            el: videojs.dom.createEl('li', {
                className: 'vjs-menu-item vjs-menu-divider',
            }),
        });
        return divider;
    }

    // Create Playback Speed Menu
    createPlaybackSpeedMenu() {
        const playbackSpeeds = [0.5, 1, 1.5, 2];

        const playbackSpeedMenu = new MenuItem(this.player(), {});

        playbackSpeeds.forEach((speed) => {
            const item = new MenuItem(this.player(), {
                label: `Speed ${speed}x`,
                selectable: true,
                selected: speed === 1,
            });

            if (speed === 1) {
                this.selectedSpeedItem = item; // Set the default selected speed item
            }

            item.on('click', () => {
                // Update the playback rate
                this.player().playbackRate(speed);

                // Unselect the previously selected speed item
                if (this.selectedSpeedItem) {
                    this.selectedSpeedItem.selected(false);
                }

                // Mark this item as selected
                item.selected(true);
                this.selectedSpeedItem = item;
            });

            item.on('mouseover', () => {
                this.menu.addClass('vjs-lock-showing');
            });

            this.menu.addChild(item);
        });

        return playbackSpeedMenu;
    }

    // Create Skip Forward Menu Item
    createSkipForward() {
        const forwardItem = new MenuItem(this.player(), {
            label: 'Forward 10s',
        });
        forwardItem.on('click', () => {
            const player = this.player();
            player.currentTime(player.currentTime() + 10)
        });
        return forwardItem;
    }

    // Create Skip Backward Menu Item
    createSkipBackward() {
        const backwardItem = new MenuItem(this.player(), {
            label: 'Previous 10s',
        });
        backwardItem.on('click', () => {
            const player = this.player();
            player.currentTime(player.currentTime() - 10)
        });
        return backwardItem;
    }

    dispose() {
        document.removeEventListener('click', this.closeMenuOnOutsideClick);
        super.dispose();
    }
}

videojs.registerComponent('SettingsButton', SettingsButton);
